import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuardCanActivateFn } from './portal/auth.guard';
import { langResolver } from './portal/lang.resolver';
import { NoInternetComponent } from './core/no-internet/no-internet.component';
import { UpdateRequiredComponent } from './core/update-required/update-required.component';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'inside',
		pathMatch: 'full',
	},
	{
		path: 'login',
		loadChildren: () => import('./features/login/login.module').then((m) => m.LoginModule),
		resolve: { langData: langResolver },
		runGuardsAndResolvers: 'always',
	},
	{
		path: 'inside',
		loadChildren: () => import('./features/inside/inside.module').then((m) => m.InsideModule),
		canActivate: [authGuardCanActivateFn],
		runGuardsAndResolvers: 'always',
	},
	{
		path: 'internet-issue',
		component: NoInternetComponent,
	},
	{
		path: 'update-required',
		component: UpdateRequiredComponent,
	},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
